import { Urls } from 'js/src/client';
import { AuthQueryParams } from 'js/src/components/auth/auth-consts';
import { getQueryParam } from 'js/src/libs/querystring';
import QueryStringManipulator from 'js/src/libs/querystring-manipulator';

/**
 * @param navigationRequired: Flag to define if navigation is required on invalid channel name.
 * TODO: while converting to TS I realized the regex string here is almost certainly incorrect as it's returning too much
 */
export function getWorkspaceSlugFromPath(navigationRequired = true): string | null {
    const match = /\/user\/(.*)\//.exec(window.location.pathname);
    if (match === null || match.length < 2) {
        if (navigationRequired) {
            alert('Could not find that channel!');
            window.location.href = Urls.DASHBOARD;
        }
        return null;
    }
    return match[1];
}

// top most common email domains from our mixpanel
const COMMON_EMAIL_REGEXPS = [
    /gmail\.com$/,
    /hotmail\.com$/,
    /yahoo\.com$/,
    /qq\.com$/,
    /outlook\.com$/,
    /mail\.ru$/,
    /icloud\.com$/,
    /163\.com$/,
    /yandex\.ru$/,
    /naver\.com$/,
    /gamil\.com$/,
    /web\.de$/,
    /gmx\.de$/,
    /gmai\.com$/,
    /live\.com$/,
    /hotmail\.fr$/,
    /guru\.smp\.belajar\.id$/,
    /yopmail\.com$/,
    /gufum\.com$/,
    /@yahoo\..*$/,
    /edu$/,
    /\.edu\./,
    /student\./,
    /example.com$/,
];

export const emailIsProbablyBusiness = (emailDomain: string): boolean => {
    return !COMMON_EMAIL_REGEXPS.some((regexp) => regexp.test(emailDomain));
};

export const userProbablyHasBusinessEmail = (): boolean => {
    return emailIsProbablyBusiness(SERVER?.USER?.email || '');
};

export const buildGoogleAuthUrl = (googleAuthUrl: string, sourceRedirectUrl: string) => {
    const invite_uuid = getQueryParam(AuthQueryParams.INVITE_UUID);
    let innerNext = sourceRedirectUrl; // e.g. "/login/?is_signup=1[&other_params]"
    innerNext = QueryStringManipulator.updateQueryStringParameter(innerNext, 'use_redirect', '1');
    if (invite_uuid) {
        innerNext = QueryStringManipulator.updateQueryStringParameter(
            innerNext,
            AuthQueryParams.INVITE_UUID,
            invite_uuid,
        );
    }

    const url = QueryStringManipulator.updateQueryStringParameter(
        googleAuthUrl,
        'next',
        encodeURIComponent(innerNext),
    );

    return url;
};
